// extracted by mini-css-extract-plugin
export default {"container":"NavigationButtons_container__hRauO","navButtonLeft":"NavigationButtons_navButtonLeft__tkCM6","navButtonRight":"NavigationButtons_navButtonRight__jYdav"};